module.exports = __webpack_public_path__ + "static/img/safe.f9fec1b0.png";